export interface ConsentSwitchProps {
  id: string
  checked: boolean
  locked?: boolean
  /** forced off + disabled (marketing while GPC is on) */
  forcedOff?: boolean
  describedBy?: string
  onChange?: (v: boolean) => void
}

/** Native checkbox with role="switch". Locked = on + disabled (Strictly necessary). */
export default function ConsentSwitch(props: ConsentSwitchProps) {
  return (
    <input
      id={props.id}
      type="checkbox"
      role="switch"
      class={`tc-switch ${props.locked || props.forcedOff ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'}`}
      data-testid={`consent-switch-${props.id}`}
      checked={props.locked ? true : props.forcedOff ? false : props.checked}
      disabled={props.locked || props.forcedOff}
      aria-checked={props.locked ? 'true' : !props.forcedOff && props.checked ? 'true' : 'false'}
      aria-describedby={props.describedBy}
      on:change={(e) => props.onChange?.((e.currentTarget as HTMLInputElement).checked)}
    />
  )
}
